import React, {Component} from 'react';
import {Segment} from 'semantic-ui-react';

class Home extends Component {
  render() {
    return (
      <Segment>
        <h1>Welcome to the NYNEX satellite Tool</h1>
        <p>
          if you have any questions contact NYNEX: 
          sales@nynex.de
          +49615150074044
        </p>
      </Segment>

    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/Home.js